const collections = {
  Collections: {
    Application: {
      Title: 'برنامه ها',
      SelectedApp: 'لیست برنامه های انتخاب شده',
      Placeholder: 'عنوان کالکشن',
      EmptyList: 'از لیست بالا می توانید محصولات مورد نظر را به کاکشن اضافه کنید',
    },
    Create: 'ایجاد کالکشن',
    CreateBanner: 'ایجاد بنر',
    EditBanner: 'ویرایش بنر',
    CreateSlide: 'ایجاد اسلایدر',
    EditSlider: 'ویرایش اسلایدر',
    Banner: 'بنر',
    AddCollectionForm: 'فرم افزودن کالکشن',
    EditCollectionForm: 'فرم ویرایش کالکشن',
    ImgURL: 'آدرس URL عکس',
    Pattern: 'الگو',
    DeleteMessage: 'برای حذف این کالکشن مطمئن هستید؟',
    Limitation: {
      Label: 'محدودیت',
    },
    ChooseImg: 'انتخاب عکس',
    Uploading: 'در حال بارگذاری عکس',
    SelectApp: 'انتخاب برنامه',
    RemoveApp: 'حذف برنامه',
    EnterUrl: 'اضافه کردن لینک',
    urlTitle: 'عنوان لینک',
    EnterTitle: 'اضافه کردن عنوان',
    EnterDesc: 'اضافه کردن توضیحات',
    Plan: 'طرح',
    NotFound: 'هیچ آیتمی به این صفحه اضافه نشده است',
    UploadValidation: 'لطفا عکس را با حداکثر ارتفاع {height} و عرض {width} وارد کنید',
    Banners: {
      title: 'لطفا طرح مورد نظر را انتخاب کنید.',
      changePattern: 'تغییر طرح',
      pic1: 'بخش۱',
      pic2: 'بخش۲',
      pic3: 'بخش۳',
      pic4: 'بخش۴',
    },
  },
}

export default collections
